export default __webpack_public_path__ + "static/media/arrow.16718c0a.svg";